import { gsap } from './gsap';

const scaleReveal = () => {
  const imageContent = gsap.utils.toArray('.scale-reveal');

  if (imageContent.length !== 0) {
    imageContent.forEach((item) => {
      gsap.set(item, { clipPath: 'inset(0% 0% 100%)', scaleY: 0.9 });
      gsap.to(item, {
        ease: 'power1',
        duration: 1.5,
        scaleY: 1,
        clipPath: 'inset(0% 0% 0%)',
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          toggleActions: 'play none none reset'
        }
      });
    });
  }
};

export default scaleReveal;
